import { MiViewColors, MiViewFontSize, MiViewSpacing } from 'miview-ui/miviewTheme';

export const tooltipStyle = {
  '& .MuiTooltip-tooltip': {
    paddingLeft: MiViewSpacing.small,
    paddingRight: MiViewSpacing.small,
    paddingTop: MiViewSpacing.xSmall,
    paddingBottom: MiViewSpacing.xSmall,
    position: 'relative',
    backgroundColor: MiViewColors.gray,
    fontSize: MiViewFontSize.xSmall,
    top: '-5px',

    '&::after': {
      content: '\'\'',
      position: 'absolute',
      top: '-10px',
      left: '50%',
      transform: 'translateX(-50%) rotate(-180deg)',
      borderWidth: '6px',
      borderStyle: 'solid',
      borderColor: `${MiViewColors.gray} transparent transparent transparent`,
    },
  },
};

export const tooltipWithHoverStyle = {
  '& .MuiTooltip-tooltip': {
    paddingLeft: MiViewSpacing.small,
    paddingRight: MiViewSpacing.small,
    paddingTop: MiViewSpacing.xSmall,
    paddingBottom: MiViewSpacing.xSmall,
    position: 'relative',
    backgroundColor: MiViewColors.gray,
    fontSize: MiViewFontSize.xSmall,
    top: '15px',

    '&::after': {
      content: '\'\'',
      position: 'absolute',
      top: '-10px',
      left: '50%',
      transform: 'translateX(-50%) rotate(-180deg)',
      borderWidth: '6px',
      borderStyle: 'solid',
      borderColor: `${MiViewColors.gray} transparent transparent transparent`,
    },
  },
};
